import { render, staticRenderFns } from "./RosterNotifications.vue?vue&type=template&id=50c9f121&scoped=true&"
import script from "@/views/RosterManagement/RosterNotifications.ts?vue&type=script&lang=ts&"
export * from "@/views/RosterManagement/RosterNotifications.ts?vue&type=script&lang=ts&"
import style0 from "@/views/RosterManagement/roster-notifications.scss?vue&type=style&index=0&id=50c9f121&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c9f121",
  null
  
)

export default component.exports